import { isObservableArray, isObservableMap } from 'mobx'
import { getSnapshot, isStateTreeNode, getPath } from '@invisr/mobx-state-tree'

const hasIdentifier = model =>
  isStateTreeNode(model) && model.$treenode.identifier
const getIdentifierAttr = model =>
  hasIdentifier(model) ? model.$treenode.identifierAttribute : undefined
const isReferenceAttr = (model, attr) =>
  isStateTreeNode(model) &&
  isStateTreeNode(model[attr]) &&
  getPath(model) + '/' + attr !== getPath(model[attr])

const _newId = (item, id) => {
  return id // `-${id}`
}
const mstClone = (model, newId = _newId, newObj) => {
  const copyMap = new Map()
  let finalizers = []

  const makeCopySnapshot = item => {
    if (isObservableArray(item)) {
      if (item.length > 0 && isReferenceAttr(item, 0)) {
        // array of references
        let snapshot = []
        // the finalizr will push new ids in
        finalizers.push(() =>
          snapshot.push(...item.map(item => copyMap.get(item)))
        )
        return snapshot
      } else {
        // simple array
        return item.map(makeCopySnapshot)
      }
    }
    if (isObservableMap(item)) {
      if (
        Array.from(item.values()).length > 0 &&
        isReferenceAttr(item, Array.from(item.keys())[0])
      ) {
        // map of references
        let snapshot = {}
        finalizers.push(() => {
          item.keys().forEach(key => {
            // TODO: what to do if the key was the old identifier?
            /* if(getIdentifier(item.get(key))+"" === key){
              snapshot[copyMap.get(item.get(key))] = copyMap.get(item.get(key))
            }else{ */
            snapshot[key] = copyMap.get(item.get(key)) || item.get(key)
            // }
          })
        })
        return snapshot
      } else {
        // simple map
        let snapshot = {}
        Array.from(item.keys()).forEach(key => {
          let newSnap = makeCopySnapshot(item.get(key))
          snapshot[copyMap.get(item.get(key))] = newSnap
        })
        return snapshot
      }
    }
    if (item && typeof item === 'object' && isStateTreeNode(item)) {
      // mostly likely a model
      let snapshot = {}
      // references will be resolved later
      let itemSnap = getSnapshot(item)
      Object.keys(itemSnap).forEach(key => {
        if (isReferenceAttr(item, key)) {
          finalizers.push(() => {
            snapshot[key] = copyMap.get(item[key]) || itemSnap[key]
          })
        } else {
          snapshot[key] = makeCopySnapshot(item[key])
        }
      })
      // model has an id, store it in copyMap
      if (hasIdentifier(item)) {
        const attr = getIdentifierAttr(item)
        const id = newId(item, item[attr])
        snapshot = { ...snapshot, [attr]: id }
        copyMap.set(item, id)
      }
      return snapshot
    }

    return item
  }

  const snapshot = makeCopySnapshot(model)

  finalizers.forEach(finalizr => finalizr())

  return newObj ? { ...snapshot, ...newObj } : snapshot
}

export default mstClone
